import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import { map, random, remove, throttle } from 'lodash';
import config from './config';
import { arrayCombine, shadeColor } from './utils'
import hash from 'object-hash';
import Swipe from 'react-easy-swipe';


const firebase = require("firebase");
require("firebase/firestore");

var db;

const typeToColorMap = {
  blocked: '#333',
  openLand: '#888',
  water: '#4eacfc',
  desert: '#fc944e',
  grass: "#0ade00",
  lava: '#de0000'
}

const points = {
  a: 100,
  b: 50,
  c: 87,
  d: 150
}

class App extends Component {
  constructor(props){
    super(props);
  }

  state = {
    content: 'Use arrow keys!',
    locX: 15 + 40,
    locY: 15 + 40,
    chunkX: '0',
    chunkY: '0',
    map4: {},
    scale: 1,
    view: [
      [{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'}, {tyleType: 'blocked'}],
      [{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'}, {tyleType: 'blocked'}],
      [{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'}, {tyleType: 'blocked'}],
      [{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'}, {tyleType: 'blocked'}],
      [{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'}, {tyleType: 'blocked'}],
      [{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'}, {tyleType: 'blocked'}],
      [{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'}, {tyleType: 'blocked'}],
      [{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'}, {tyleType: 'blocked'}],
      [{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'}, {tyleType: 'blocked'}],
      [{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'},{tyleType: 'blocked'}, {tyleType: 'blocked'}]
    ]
  };

  handleKeypress = throttle((event) => {
    const keyCode = event.keyCode;

    switch(keyCode) {
      // Left
      case 65:
      case 37: {
        const newLoc = this.state.locX - 2;
        if (newLoc < 40) {
          const newChunkAddress = (+this.state.chunkX - 1).toString();
          this.recenterAndLoadChunks({
            chunkX: newChunkAddress,
            chunkY: this.state.chunkY,
            locX: newLoc + 40
          }, 'left');
          window.localStorage.setItem('chunkX', newChunkAddress);
        } else {
          this.setState({
            locX: newLoc,
            content: 'Key detected: left'
          });
        }
        window.localStorage.setItem('locX', newLoc);
        break;
      }
      // Right
      case 68:
      case 39: {
        const newLoc = this.state.locX + 2;
        if (newLoc > 80) {
          const newChunkAddress = (+this.state.chunkX + 1).toString();
          this.recenterAndLoadChunks({
            chunkX: newChunkAddress,
            chunkY: this.state.chunkY,
            locX: newLoc - 40
          }, 'right');
          window.localStorage.setItem('chunkX', newChunkAddress);
        } else {
          this.setState({
            locX: newLoc,
            content: 'Key detected: right'
          });
        }
        window.localStorage.setItem('locX', newLoc);
        break;
      }
      // Up
      case 87:
      case 38: {
        const newLoc = this.state.locY - 1;
        if (newLoc < 40) {
          const newChunkAddress = (+this.state.chunkY - 1).toString();
          this.recenterAndLoadChunks({
            chunkX: this.state.chunkX,
            chunkY: newChunkAddress,
            locY: newLoc + 40
          }, 'up');
          window.localStorage.setItem('chunkY', newChunkAddress);
        } else {
          this.setState({
            locY: newLoc,
            content: 'Key detected: up'
          });
        }
        window.localStorage.setItem('locY', newLoc);
        break;
      }
      // Down
      case 83:
      case 40: {
        const newLoc = this.state.locY + 1;
        if (newLoc > 80) {
          const newChunkAddress = (+this.state.chunkY + 1).toString();
          this.recenterAndLoadChunks({
            chunkX: this.state.chunkX,
            chunkY: newChunkAddress,
            locY: newLoc - 40
          }, 'down');
          window.localStorage.setItem('chunkY', newChunkAddress)
        } else {
          this.setState({
            locY: newLoc,
            content: 'Key detected: down'
          });
        }
        window.localStorage.setItem('locY', newLoc);
        break;
      }
      case 187: {
        this.zoomIn();
        break;
      }
      case 189: {
        this.zoomOut();
        break;
      }
      case 72: {
        console.table([
          [hash(this.state.map0).substr(0, 3), hash(this.state.map1).substr(0, 3), hash(this.state.map2).substr(0, 3)],
          [hash(this.state.map3).substr(0, 3), hash(this.state.map4).substr(0, 3), hash(this.state.map5).substr(0, 3)],
          [hash(this.state.map6).substr(0, 3), hash(this.state.map7).substr(0, 3), hash(this.state.map8).substr(0, 3)]
        ]);
        break;
      }
      case 74: {
        console.table([
        ['map0: ' + this.state.map0[0][0].address.split('_')[0] + ',' + this.state.map0[0][0].address.split('_')[1],
        'map1: ' + this.state.map1[0][0].address.split('_')[0] + ',' + this.state.map1[0][0].address.split('_')[1],
        'map2: ' + this.state.map2[0][0].address.split('_')[0] + ',' + this.state.map2[0][0].address.split('_')[1]],

        ['map3: ' + this.state.map3[0][0].address.split('_')[0] + ',' + this.state.map3[0][0].address.split('_')[1],
        'map4: ' + this.state.map4[0][0].address.split('_')[0] + ',' + this.state.map4[0][0].address.split('_')[1],
        'map5: ' + this.state.map5[0][0].address.split('_')[0] + ',' + this.state.map5[0][0].address.split('_')[1]],

        ['map6: ' + this.state.map6[0][0].address.split('_')[0] + ',' + this.state.map6[0][0].address.split('_')[1],
        'map7: ' + this.state.map7[0][0].address.split('_')[0] + ',' + this.state.map7[0][0].address.split('_')[1],
        'map8: ' + this.state.map8[0][0].address.split('_')[0] + ',' + this.state.map8[0][0].address.split('_')[1]]
        ])
        break;
      }
      default: {
        console.log('Unrecognized key', keyCode);
      }
    }
  }, 100)

  recenterAndLoadChunks(newChunk, dir) {
    console.log('recenterAndLoadChunks', newChunk)
      // TODOOOOO:  REASSIGN LISTENERS< DON"T JUST SHIFT MAPS
    switch (dir) {
      case 'left': {
        this.setState(Object.assign({}, newChunk, {
          map3: this.state.map0,
          map4: this.state.map1,
          map5: this.state.map2,
          map6: this.state.map3,
          map7: this.state.map4,
          map8: this.state.map5
        }));
        break;
      }
      case 'right': {
        this.setState(Object.assign({}, newChunk, {
          map0: this.state.map3,
          map1: this.state.map4,
          map2: this.state.map5,
          map3: this.state.map6,
          map4: this.state.map7,
          map5: this.state.map8,
        }));
        break;
      }
      case 'up': {
        this.setState(Object.assign({}, newChunk, {
          map1: this.state.map0,
          map2: this.state.map1,
          map4: this.state.map3,
          map5: this.state.map4,
          map7: this.state.map6,
          map8: this.state.map7,
        }));
        break;
      }
      case 'down': {
        this.setState(Object.assign({}, newChunk, {
          map0: this.state.map1,
          map1: this.state.map2,
          map3: this.state.map4,
          map4: this.state.map5,
          map6: this.state.map7,
          map7: this.state.map8,
        }));
        break;
      }
    }

    // this.setState(newChunk)
    this.registerListeners(newChunk);
  }

  calculateVisibleMap(newCoords) {

    let newView = {
      0: {0: {tyleType: 'blocked'}, 1: {tyleType: 'blocked'}, 2: {tyleType: 'blocked'}, 3: {tyleType: 'blocked'}, 4: {tyleType: 'blocked'}, 5: {tyleType: 'blocked'}, 6: {tyleType: 'blocked'}, 7: {tyleType: 'blocked'}, 8: {tyleType: 'blocked'}},
      1: {0: {tyleType: 'blocked'}, 1: {tyleType: 'blocked'}, 2: {tyleType: 'blocked'}, 3: {tyleType: 'blocked'}, 4: {tyleType: 'blocked'}, 5: {tyleType: 'blocked'}, 6: {tyleType: 'blocked'}, 7: {tyleType: 'blocked'}, 8: {tyleType: 'blocked'}},
      2: {0: {tyleType: 'blocked'}, 1: {tyleType: 'blocked'}, 2: {tyleType: 'blocked'}, 3: {tyleType: 'blocked'}, 4: {tyleType: 'blocked'}, 5: {tyleType: 'blocked'}, 6: {tyleType: 'blocked'}, 7: {tyleType: 'blocked'}, 8: {tyleType: 'blocked'}},
      3: {0: {tyleType: 'blocked'}, 1: {tyleType: 'blocked'}, 2: {tyleType: 'blocked'}, 3: {tyleType: 'blocked'}, 4: {tyleType: 'blocked'}, 5: {tyleType: 'blocked'}, 6: {tyleType: 'blocked'}, 7: {tyleType: 'blocked'}, 8: {tyleType: 'blocked'}},
      4: {0: {tyleType: 'blocked'}, 1: {tyleType: 'blocked'}, 2: {tyleType: 'blocked'}, 3: {tyleType: 'blocked'}, 4: {tyleType: 'blocked'}, 5: {tyleType: 'blocked'}, 6: {tyleType: 'blocked'}, 7: {tyleType: 'blocked'}, 8: {tyleType: 'blocked'}},
      5: {0: {tyleType: 'blocked'}, 1: {tyleType: 'blocked'}, 2: {tyleType: 'blocked'}, 3: {tyleType: 'blocked'}, 4: {tyleType: 'blocked'}, 5: {tyleType: 'blocked'}, 6: {tyleType: 'blocked'}, 7: {tyleType: 'blocked'}, 8: {tyleType: 'blocked'}},
      6: {0: {tyleType: 'blocked'}, 1: {tyleType: 'blocked'}, 2: {tyleType: 'blocked'}, 3: {tyleType: 'blocked'}, 4: {tyleType: 'blocked'}, 5: {tyleType: 'blocked'}, 6: {tyleType: 'blocked'}, 7: {tyleType: 'blocked'}, 8: {tyleType: 'blocked'}},
      7: {0: {tyleType: 'blocked'}, 1: {tyleType: 'blocked'}, 2: {tyleType: 'blocked'}, 3: {tyleType: 'blocked'}, 4: {tyleType: 'blocked'}, 5: {tyleType: 'blocked'}, 6: {tyleType: 'blocked'}, 7: {tyleType: 'blocked'}, 8: {tyleType: 'blocked'}},
      8: {0: {tyleType: 'blocked'}, 1: {tyleType: 'blocked'}, 2: {tyleType: 'blocked'}, 3: {tyleType: 'blocked'}, 4: {tyleType: 'blocked'}, 5: {tyleType: 'blocked'}, 6: {tyleType: 'blocked'}, 7: {tyleType: 'blocked'}, 8: {tyleType: 'blocked'}},
      9: {0: {tyleType: 'blocked'}, 1: {tyleType: 'blocked'}, 2: {tyleType: 'blocked'}, 3: {tyleType: 'blocked'}, 4: {tyleType: 'blocked'}, 5: {tyleType: 'blocked'}, 6: {tyleType: 'blocked'}, 7: {tyleType: 'blocked'}, 8: {tyleType: 'blocked'}},
      10: {0: {tyleType: 'blocked'}, 1: {tyleType: 'blocked'}, 2: {tyleType: 'blocked'}, 3: {tyleType: 'blocked'}, 4: {tyleType: 'blocked'}, 5: {tyleType: 'blocked'}, 6: {tyleType: 'blocked'}, 7: {tyleType: 'blocked'}, 8: {tyleType: 'blocked'}},
      11: {0: {tyleType: 'blocked'}, 1: {tyleType: 'blocked'}, 2: {tyleType: 'blocked'}, 3: {tyleType: 'blocked'}, 4: {tyleType: 'blocked'}, 5: {tyleType: 'blocked'}, 6: {tyleType: 'blocked'}, 7: {tyleType: 'blocked'}, 8: {tyleType: 'blocked'}},
      12: {0: {tyleType: 'blocked'}, 1: {tyleType: 'blocked'}, 2: {tyleType: 'blocked'}, 3: {tyleType: 'blocked'}, 4: {tyleType: 'blocked'}, 5: {tyleType: 'blocked'}, 6: {tyleType: 'blocked'}, 7: {tyleType: 'blocked'}, 8: {tyleType: 'blocked'}},
      13: {0: {tyleType: 'blocked'}, 1: {tyleType: 'blocked'}, 2: {tyleType: 'blocked'}, 3: {tyleType: 'blocked'}, 4: {tyleType: 'blocked'}, 5: {tyleType: 'blocked'}, 6: {tyleType: 'blocked'}, 7: {tyleType: 'blocked'}, 8: {tyleType: 'blocked'}},
      14: {0: {tyleType: 'blocked'}, 1: {tyleType: 'blocked'}, 2: {tyleType: 'blocked'}, 3: {tyleType: 'blocked'}, 4: {tyleType: 'blocked'}, 5: {tyleType: 'blocked'}, 6: {tyleType: 'blocked'}, 7: {tyleType: 'blocked'}, 8: {tyleType: 'blocked'}},
      15: {0: {tyleType: 'blocked'}, 1: {tyleType: 'blocked'}, 2: {tyleType: 'blocked'}, 3: {tyleType: 'blocked'}, 4: {tyleType: 'blocked'}, 5: {tyleType: 'blocked'}, 6: {tyleType: 'blocked'}, 7: {tyleType: 'blocked'}, 8: {tyleType: 'blocked'}},
      16: {0: {tyleType: 'blocked'}, 1: {tyleType: 'blocked'}, 2: {tyleType: 'blocked'}, 3: {tyleType: 'blocked'}, 4: {tyleType: 'blocked'}, 5: {tyleType: 'blocked'}, 6: {tyleType: 'blocked'}, 7: {tyleType: 'blocked'}, 8: {tyleType: 'blocked'}},
      17: {0: {tyleType: 'blocked'}, 1: {tyleType: 'blocked'}, 2: {tyleType: 'blocked'}, 3: {tyleType: 'blocked'}, 4: {tyleType: 'blocked'}, 5: {tyleType: 'blocked'}, 6: {tyleType: 'blocked'}, 7: {tyleType: 'blocked'}, 8: {tyleType: 'blocked'}},
      18: {0: {tyleType: 'blocked'}, 1: {tyleType: 'blocked'}, 2: {tyleType: 'blocked'}, 3: {tyleType: 'blocked'}, 4: {tyleType: 'blocked'}, 5: {tyleType: 'blocked'}, 6: {tyleType: 'blocked'}, 7: {tyleType: 'blocked'}, 8: {tyleType: 'blocked'}}
    }

    if (this.state.map0 && this.state.map1 && this.state.map2 && this.state.map3 && this.state.map4 && this.state.map5 && this.state.map6 && this.state.map7 && this.state.map8) {
      // Should array combine be done here, or, when there is a response from the listener?
      let theMap = arrayCombine([this.state.map0, this.state.map1, this.state.map2, this.state.map3, this.state.map4, this.state.map5, this.state.map6, this.state.map7, this.state.map8]);
      for(let i = 0; i < Object.keys(newView).length; i++) {
        for(let j = 0; j < Object.keys(newView[0]).length; j++) {
          if(newCoords.locX + i >= 0 && newCoords.locX + i < Object.keys(theMap).length) {
            newView[i][j] = theMap[newCoords.locX + i][newCoords.locY + j];
          }
        }
      }
    }

    return newView;
  }

  changeType(address, tileType) {
    console.log(`Address: ${address} Hash: `)
    const loc = address.split('_');
    const tileTypes = remove(['blocked', 'openLand', 'water', 'desert', 'grass', 'lava'], (n) => n !== tileType);
    let newType = {};
    newType[`cells.${loc[2]}.${loc[3]}.tyleType`] = tileTypes[random(0, tileTypes.length - 1)];
    db.collection("chunks").doc(loc[0].toString()).collection('chunks').doc(loc[1].toString()).update(newType);
  }

  componentWillMount() {
    if (!firebase.apps.length) {
      firebase.initializeApp(config);
    }
    db = firebase.firestore()

    // Disable deprecated features
    db.settings({
      timestampsInSnapshots: true
    });

    this.registerListeners();
    this.updateDimensions();
  }

  updateDimensions() {
    console.log('updateDimensions')
    this.setState({
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight
    });
  }

  componentDidMount() {
    window.addEventListener("resize", () => { this.updateDimensions() });
    document.querySelector('#keyArea').focus();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", () => { this.updateDimensions() });
  }

  zoomIn() {
    if (this.state.scale > 1) {
      this.setState({
        scale: this.state.scale - 1
      })
    }
  }

  zoomOut() {
    this.setState({
      scale: this.state.scale + 1
    })
  }

  registerListeners(newChunk, cb) {
    let chunkInfo = newChunk;
    if (!chunkInfo) {
      console.log("No chunk info")
      chunkInfo = {
        chunkX: +this.state.chunkX,
        chunkY: +this.state.chunkY
      }
    }

    // Set up listeners
    const countMap = {
      [-1]: {
        [-1]: 0,
        0: 1,
        1: 2
      },
      0: {
        [-1]: 3,
        0: 4,
        1: 5
      },
      1: {
        [-1]: 6,
        0: 7,
        1: 8
      }
    }
    for (let i = -1; i < 2; i++) {
      for (let j = -1; j < 2; j++) {
        const listener = db.collection("chunks").doc((+chunkInfo.chunkX + i).toString()).collection('chunks').doc((+chunkInfo.chunkY + j).toString()).onSnapshot((doc) => {
          this.setState({
            [`map${countMap[i][j]}`]: doc.data().cells
          });
        });
        // kill old listeners if they exist
        const listenerLoc = `map${countMap[i][j]}listener`;
        if(this.state[listenerLoc]){
          this.state[listenerLoc]();
        }
        this.setState({
          [listenerLoc]: listener
        });
      }
    }

    if(cb) {
      cb();
    }
  }

  onSwipeMove(position, event) {
    if (position.x > 10) {
      this.handleKeypress({
        keyCode: 65
      });
    }
    if (position.x < -10) {
      this.handleKeypress({
        keyCode: 68
      });
    }
    if (position.y < -10) {
      this.handleKeypress({
        keyCode: 83
      });
    }
    if (position.y > 10) {
      this.handleKeypress({
        keyCode: 87
      });
    }
    console.log('swiping')
  }

  render() {
    const scaledPoints = {
      a: points.a / this.state.scale,
      b: points.b / this.state.scale,
      c: points.c / this.state.scale,
      d: points.d / this.state.scale
    }
    return (
      <Swipe onSwipeMove={(p, e) => { this.onSwipeMove(p, e) }}>
        <div onKeyDown={(e) => { e.persist(); this.handleKeypress(e) }} onKeyDown={(e) => { e.persist(); this.handleKeypress(e) }} id="keyArea" tabIndex="1">
          <div className="hoverPanel">
            {this.state.content}

            <div>
              <p>chunkX: {this.state.chunkX}</p>
              <p>chunkY: {this.state.chunkY}</p>
            </div>
            <span className="clickable" onClick={() => { this.zoomIn() }}>+</span> <span className="clickable" onClick={() => { this.zoomOut() }}>-</span>
          </div>
          <div className="App"  style={{width: this.state.windowWidth, height: this.state.windowHeight, backgroundColor: 'white'}} >
            <svg viewBox="0 0 1350 1290">
              <g>
                <g className="grid">
                  {map(this.calculateVisibleMap({locX: this.state.locX, locY: this.state.locY}), (row, x) => {
                    return map(row, (cell, y) => {
                      cell = cell || {tyleType: 'blocked', address: `${x}-${y}`};
                      const points = `${scaledPoints.a},0 ${scaledPoints.b},-${scaledPoints.c} -${scaledPoints.b},-${scaledPoints.c} -${scaledPoints.a},-0 -${scaledPoints.b},${scaledPoints.c} ${scaledPoints.b},${scaledPoints.c}`;
                      return (
                        <g key={`${cell.address || x + '-' + y}-${cell.tyleType}`} keyz={`${cell.address || x + '-' + y}-${cell.tyleType}`} transform={`translate(${x*scaledPoints.d},${x % 2 === 0 ? y*(scaledPoints.c * 2) : y*(scaledPoints.c * 2) + scaledPoints.c})`}>
                          <g>
                            <polygon points={points} className={cell.tyleType} onClick={() => { this.changeType(cell.address, cell.tyleType) }}></polygon>

                          </g>
                        </g>
                      );
                    })
                  })}
                </g>
              </g>
            </svg>
          </div>
        </div>
      </Swipe>
    );
  }
}

export default App;
